// var host = "https://api-a19.smicee.com";
var host = "https://api.futurebangladeshyouwant.com";



const { h } = require("vue");

module.exports = {
    V1API: {
        'getAccessToken': host + '/api/auth/token',
        'refreshAccessToken': host + '/api/auth/token/refresh/',
        'verifyLogin': host + '/api/auth/token/verify',
        
        //Future Bangladesh Admin APIs
        'get_voice_list' : host+ '/api/form/voice/list',
        'get_pledge_signing_list' : host+ '/api/form/pledge/list',
        'get_marathon_list': host + '/api/form/marathon/list',


        'get_announcement_list' : host + '/api/announcement/list',
        'create_announcement': host + '/api/announcement/create',
        'update_announcement': host + '/api/announcement/update/',
        'get_announcement_detail': host + '/api/announcement/detail/',
        'delete_announcement': host+ '/api/announcement/delete/',


        
        
    }
};
